import React, { useState, useEffect } from 'react';

const CountUp = ({ end, suffix = '', duration = 2000 }) => {
    const [count, setCount] = useState(0);
    
    useEffect(() => {
        const step = end / (duration / 16); // 16ms is approx one frame at 60fps
        let current = 0;
        const timer = setInterval(() => {
            current += step;
            if (current >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(current));
            }
        }, 16);
        
        return () => clearInterval(timer);
    }, [end, duration]);
    
    return <span>{count}{suffix}</span>;
};

export default CountUp;